@if (inited) {
    <p-table [value]="pupils" class="p-datatable-gridlines" [frozenValue]="[{}]">
    <ng-template pTemplate="header">
      <tr>
        <th>Nachname</th>
        <th>Vorname</th>
        @for (month of monthNames; track month) {
          <th><div class="center">{{month}}</div></th>
        }
        <th><div class="center">Gesamt</div></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-pupil let-index="rowIndex">
      <tr [pSelectableRow]="pupil">
        <td>{{pupil.lastName}}</td>
        <td>{{pupil.firstName}}</td>
        @for (month of monthNames; track month; let monthIndex = $index) {
          <td [pTooltip]="toolTips[index][monthIndex]">
            <div class="center" [class.excused]="sum[index][monthIndex][0] > 0 || sum[index][monthIndex][2]" [class.mouse-pointer]="links[index][monthIndex].length > 0" (click)="click(index, monthIndex)">{{sum[index][monthIndex][0] > 0 || sum[index][monthIndex][2] ? ((sum[index][monthIndex][0] > 0 ? sum[index][monthIndex][0] : '-') + '/' + (sum[index][monthIndex][2] > 0 ? sum[index][monthIndex][2] : '-')): '-'}}</div>
            <div class="center" [class.unexcused]="sum[index][monthIndex][1] > 0 || sum[index][monthIndex][3]" [class.mouse-pointer]="links[index][monthIndex].length > 0" (click)="click(index, monthIndex)">{{sum[index][monthIndex][1] > 0 || sum[index][monthIndex][3] ? ((sum[index][monthIndex][1] > 0 ? sum[index][monthIndex][1] : '-') + '/' + (sum[index][monthIndex][3] > 0 ? sum[index][monthIndex][3] : '-')): '-'}}</div>
          </td>
        }
        <td>
          <div class="center" [ngClass]="total[index][0] > 0 || total[index][2] > 0 ? 'excused mouse-pointer' : ''">{{total[index][0] > 0 || total[index][2] ? ((total[index][0] > 0 ? total[index][0] : '-') + '/' + (total[index][2] > 0 ? total[index][2] : '-')): '-'}}</div>
          <div class="center" [ngClass]="total[index][1] > 0 || total[index][3] > 0 ? 'excused mouse-pointer' : ''">{{total[index][1] > 0 || total[index][3] ? ((total[index][1] > 0 ? total[index][1] : '-') + '/' + (total[index][3] > 0 ? total[index][3] : '-')): '-'}}</div>
        </td>
      </tr>
    </ng-template>
  </p-table>
}
<p-dialog header="Sprung zur Unterrichtseinheit" [(visible)]="dialogVisible" [modal]=true [style]="{width: '700px', height: '400px'}" [baseZIndex]="10000" [draggable]=false [resizable]=false>
  <div class="grid">
    @for (link of dialogLinks; track link) {
      <a class="col-12" href=# [routerLink]="['/enaio-certificates', 'class-registers', 'lesson', link.id]">{{link.title}}</a>
    }
  </div>
  <p-footer>
    <button type="button" pButton icon="fas fa-times" (click)="dialogVisible = false" label="Schließen"></button>
  </p-footer>
</p-dialog>
